import { z } from 'zod';
import '@apexdesigner/schema-tools';

export const mintedPersonalAccessToken = z
  .object({
    token: z
      .string()
      .describe('Token - The plaintext token; shown exactly once'),

    id: z.number().describe('ID - Token record id'),

    name: z.string().describe('Name - User-supplied label'),

    displayPrefix: z
      .string()
      .describe('Display Prefix - Redacted form, e.g. "adp_…f3a9"'),

    expiresAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('Expires At - Optional expiry'),
  })
  .describe(
    'Result of the `mint` behavior. The `token` field is the only place the plaintext ever appears — it is not stored and cannot be retrieved again.',
  )
  .as('MintedPersonalAccessToken', { embedded: true });

export { mintedPersonalAccessToken as mintedPersonalAccessTokenSchema };
